import "./style.css";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Payment timeout constant (in milliseconds)
const PAYMENT_TIMEOUT_IN_SECOND = 5000;

export default function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(PAYMENT_TIMEOUT_IN_SECOND / 1000);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const urlParams = new URLSearchParams(location.search);
    const bookingId = urlParams.get("booking_id");
    const caddyId = urlParams.get("caddy_id");
    
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      navigate(`/book_caddy/${caddyId}/${bookingId}`, { replace: true });
    }, PAYMENT_TIMEOUT_IN_SECOND);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [location, navigate]);

  return (
    <div className="payment-success-wrapper">
      <div className={`payment-success-card ${isVisible ? "animate-in" : ""}`}>
        <div className="icon-wrapper">
          <div className="success-circle">
            <svg
              className="checkmark animated-checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
              width={100}
              height={100}
            >
              <circle
                className="checkmark__circle"
                cx="26"
                cy="26"
                r="23"
                fill="none"
                stroke="#10b981"
                strokeWidth="3"
              />
              <path
                className="checkmark__check"
                fill="none"
                stroke="#10b981"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
          </div>
        </div>

        {/* Success Message */}
        <div className="success-content">
          <h1 className="success-title">Payment Successful!</h1>
          <p className="success-subtitle">
            Your payment has been approved
          </p>

          {/* Countdown Display */}
          <div className="countdown-section">
            <p className="countdown-text">Redirecting you to booking page in</p>
            <div className="countdown-display">
              <span className="countdown-number">{countdown}</span>
              <span className="countdown-unit">seconds</span>
            </div>
          </div>

          <div className="progress-container">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{
                  width: `${
                    ((PAYMENT_TIMEOUT_IN_SECOND / 1000 - countdown) /
                      (PAYMENT_TIMEOUT_IN_SECOND / 1000)) *
                    100
                  }%`,
                  transition: "width 1s ease-out",
                }}
              />
            </div>
            <p className="progress-text">
              {Math.round(
                ((PAYMENT_TIMEOUT_IN_SECOND / 1000 - countdown) /
                  (PAYMENT_TIMEOUT_IN_SECOND / 1000)) *
                  100
              )}
              % Complete
            </p>
          </div>

          <div className="info-card">
            <div className="info-icon">
              <svg
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
              </svg>
            </div>
            <p className="info-text">
              <strong>Note:</strong>{" "}
              Please do not close this page until confirmation is received
            </p>
          </div>          {/* <button
            className="skip-button"
            onClick={() => {
              const urlParams = new URLSearchParams(location.search);
              const booking = urlParams.get("booking_id");
              const caddy = urlParams.get("caddy_id");
              navigate(`/book_caddy/${caddy}/${booking}`, { replace: true });
            }}
          >
            ข้ามไปเลย →
          </button> */}
        </div>
      </div>

      <div className="success-particles">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${3 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
